import getConfig from 'next/config';
import { HTTPClient } from '../lib/api';
import firebase from 'firebase/compat/app';
import { initializeApp } from 'firebase/app';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

const getFirebaseConfig = async () => {
  return await HTTPClient(`${BASE_URL_MEDIA}api/accounts/firebase-config/`, {});
};

const initializeFirebase = async () => {
  const loginConfig = await getFirebaseConfig();

  if (!firebase.apps.length) {
    initializeApp(loginConfig);
  } else {
    firebase.app();
  }
};

export default initializeFirebase;
